/**
 * Admin Dashboard Configuration
 * 
 * Centralized configuration for admin dashboard behavior and permissions.
 */

export const ADMIN_CONFIG = {
  /**
   * Controls whether student employees are redirected to admin dashboard
   * instead of student dashboard when accessing the root path.
   * 
   * Set to true to give student employees admin dashboard access by default.
   * Set to false to treat them like regular students for navigation.
   */
  STUDENT_EMPLOYEE_REDIRECT_TO_ADMIN: false,
  
  /**
   * Future configuration options can be added here:
   * - ENABLE_AUDIT_LOGGING: true/false
   * - MAX_SEARCH_RESULTS: number
   * - SESSION_TIMEOUT: number (minutes)
   */
};

export default ADMIN_CONFIG;